import { render, staticRenderFns } from "./Impressoes.vue?vue&type=template&id=b9115342&scoped=true&"
import script from "./Impressoes.vue?vue&type=script&lang=js&"
export * from "./Impressoes.vue?vue&type=script&lang=js&"
import style0 from "./Impressoes.vue?vue&type=style&index=0&id=b9115342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9115342",
  null
  
)

export default component.exports